export default __webpack_public_path__ + "static/media/Queen Blade.28ec55a3.jpg";